// Really this should be incorporated into utils but for an abundance of caution I am keeping it separate for now
// token is a simple base62 encoded timestamp that is valid for 24 hours before and after is was created

class TimestampEncoder {
  constructor() {
    this.base62Chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  }

  encodeBase62(num) {
    let encoded = '';
    while (num) {
      encoded = this.base62Chars[num % 62] + encoded;
      num = Math.floor(num / 62);
    }
    return encoded;
  }

  decodeBase62(str) {
    let decoded = 0;
    if (!str || typeof str !== 'string') return decoded;
    for (let i = 0; i < str.length; i++) {
      decoded = decoded * 62 + this.base62Chars.indexOf(str[i]);
    }
    return decoded;
  }

  validate(str) {
    const now = Date.now();
    const decoded = this.decodeBase62(str);
    const twentyFourHours = 24 * 60 * 60 * 1000;

    return ((now - twentyFourHours) < decoded) && ((now + twentyFourHours) > decoded);
  }
}

const encoder = new TimestampEncoder();
const token = new URLSearchParams(window.location.search).get('token');
const isValid = encoder.validate(token);

if (!isValid) {
  window.location.replace('/');
}
